import { render, staticRenderFns } from "./waterparams.vue?vue&type=template&id=7900a748&"
import script from "./waterparams.vue?vue&type=script&lang=ts&"
export * from "./waterparams.vue?vue&type=script&lang=ts&"
import style0 from "./waterparams.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "waterparams.vue"
export default component.exports